// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { DrugGroupActions, DrugGroupActionTypes } from '../_actions/drug-group.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { DrugGroup } from '../_models/drug-group.model';

// tslint:disable-next-line:no-empty-interface
export interface DrugGroupsState extends EntityState<DrugGroup> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedDrugGroupId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<DrugGroup> = createEntityAdapter<DrugGroup>();

export const initialDrugGroupsState: DrugGroupsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedDrugGroupId: undefined,
  showInitWaitingMessage: true,
});

export function drugGroupsReducer(
  state = initialDrugGroupsState,
  action: DrugGroupActions,
): DrugGroupsState {
  switch (action.type) {
    case DrugGroupActionTypes.DrugGroupsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedDrugGroupId: undefined,
      };
    case DrugGroupActionTypes.DrugGroupsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case DrugGroupActionTypes.DrugGroupCreated:
      return adapter.addOne(action.payload.drugGroup, {
        ...state,
        lastCreatedDrugGroupId: action.payload.drugGroup.id,
      });
    case DrugGroupActionTypes.DrugGroupUpdated:
      return adapter.updateOne(action.payload.partialDrugGroup, state);
    case DrugGroupActionTypes.DrugGroupDeleted:
      return adapter.removeOne(action.payload.id, state);
    case DrugGroupActionTypes.DrugGroupsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case DrugGroupActionTypes.DrugGroupsPageLoaded: {
      return adapter.addMany(action.payload.drugGroups, {
        ...initialDrugGroupsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case DrugGroupActionTypes.ThrowDrugGroupError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case DrugGroupActionTypes.FireDrugGroupSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getDrugGroupState = createFeatureSelector<DrugGroupsState>('drugGroups');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
